import { render, staticRenderFns } from "./CapitalMgt.vue?vue&type=template&id=cb12d082&"
import script from "./CapitalMgt.vue?vue&type=script&lang=js&"
export * from "./CapitalMgt.vue?vue&type=script&lang=js&"
import style0 from "./CapitalMgt.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports